import Image from "next/image";
import { useTranslation } from "next-i18next";
import { m } from "framer-motion";
import { useMediaQuery } from "usehooks-ts";
import React from "react";

const PackagesSection = () => {
  const { i18n } = useTranslation();
  const rtl = i18n.dir() === "rtl";
  const [key, setKey] = React.useState(0);
  const isMd = useMediaQuery("(min-width: 900px)", {
    initializeWithValue: false,
  });

  React.useEffect(() => {
    setKey(isMd ? 2 : 3);
  }, [isMd]);

  return (
    <section className="flex w-full  py-16">
      <div className="container flex flex-col items-start justify-center gap-10 px-4">
        <div className="flex w-full flex-col items-start justify-center gap-5">
          <h2 className="text-4xl font-bold text-primary-700">Our Packages</h2>
          <div className="text-base font-medium leading-normal text-auto-black/60">
            We offer a wide range of packaging sizes to meet your market needs.
          </div>
        </div>
        <div key={key} className="grid w-full grid-cols-1 gap-8 md:grid-cols-3">
          <PackageCard
            image="/img/products/palmera/peas-carrot-400a.png"
            title="Retail"
            desc="350gm-1kg"
            initial={
              isMd
                ? { opacity: 0, x: rtl ? 100 : -100 }
                : { opacity: 0, y: -50 }
            }
          />
          <PackageCard
            image="/img/products/neoteric/mixed-3-way-2500a.png"
            title="Horeca"
            desc="1-5kg"
            initial={isMd ? { opacity: 0, y: -50 } : { opacity: 0, y: -50 }}
          />
          <PackageCard
            image="/img/products/bulk.png"
            title="Bulk"
            desc="10-40kg"
            initial={
              isMd
                ? { opacity: 0, x: rtl ? -100 : 100 }
                : { opacity: 0, y: -50 }
            }
          />
        </div>
      </div>
    </section>
  );
};

export default PackagesSection;

const PackageCard = ({ image, title, desc, initial }) => {
  return (
    <m.div
      className="flex w-full flex-col items-center justify-center gap-3 py-4"
      initial={initial}
      whileInView={{
        opacity: 1,
        x: 0,
        y: 0,
        transition: { duration: 0.5, ease: "easeOut" },
      }}
      viewport={{ once: true }}
    >
      <div className="relative aspect-video w-full">
        <Image
          src={image}
          alt={title}
          fill
          className="absolute inset-0 object-contain object-center drop-shadow-[10px_5px_7px_rgba(0,0,0,0.4)]"
          sizes="(max-width: 600px) 300px, (max-width: 900px) 450px, (max-width: 1200px) 200, 200"
        />
      </div>
      <div className="flex flex-col items-center justify-center gap-0 text-center">
        <div className="text-3xl font-bold text-auto-black/70">{title}</div>
        <div className="text-lg font-medium text-auto-black/60">{desc}</div>
      </div>
    </m.div>
  );
};
